import axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import router from '../routes/router';
import EventBus from '@/events/event.bus';

Vue.router = router;

Vue.use(VueAxios, axios);

const baseDomain = process.env.VUE_APP_ROOT_API;
const baseURL = `${baseDomain}api`;

Vue.axios.defaults.baseURL = baseURL;

Vue.axios.defaults.headers.common['Accept'] = 'application/json';
Vue.axios.defaults.headers.common['Content-Type'] = 'application/json';
Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Vue.axios.defaults.headers.common['Response-Type'] = 'application/json';

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  fetchData: {
    success: (res) => Vue.auth.user(EventBus.updatePermissions(res.data)),
  },
  rolesVar: 'permissionsList',
});

export default Vue.axios;
